import {css} from '@emotion/css';
import {spacing} from '@fo/shared/styles/variables';

export default {
  container: css`
    label: redirectToTideModal;
    display: flex;
    justify-content: center;
    padding: 0;
  `,
  informationBox: css`
    label: redirectToTideModal__informationBox;
    label: redirectToTideModal__informationBox;
    max-width: 48rem;
    && {
      padding: 0;
      margin: ${spacing.S} 0 0;
    }
  `,
  informationBoxCopy: css`
    margin-bottom: ${spacing.S};
  `,
};
